import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclUtilAvlService {

  constructor() { }

  getRelatedDocument(data, kind) {
    let retVal = {};

    if (data && data.imeiDocumentsRel && data.imeiDocumentsRel.length > 0 && kind) {
        retVal = data.imeiDocumentsRel.find (function(x) {
          if (!x || !x.imeiDocumentType) {
              return false;
          }

          if (Array.isArray(x.imeiDocumentType)) {
            const temp = x.imeiDocumentType.find(y => (y === kind));

            if (temp) {
              // logger.info("found event that have imeiDocumentType as array:");
              // logger.info(data);
              return true;
            } else {
              return false;
            }
          } else {
            return x.imeiDocumentType === kind;
          }
        });
        // retVal = data.imeiDocumentsRel[0];
    }
    return retVal;
  }
}
